module.exports = __webpack_public_path__ + "img/footerLogo.c4131949.gif";